import * as React from 'react';
import { useIntl } from 'react-intl';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { Recipient } from 'pages/Settings/components/settings/jobs/monthly-reports/components/recipientsList/Recipient';
import { RecipientEditorDialog } from 'pages/Settings/components/settings/jobs/monthly-reports/components/recipientsList/RecipientEditorDialog';
import { MonthlyReportRecipient } from 'redux/ducks/monthlyReportRecipients/types';
import { MonthlyReportTemplateType } from 'redux/ducks/settings';

export interface OwnProps {
  recipients: MonthlyReportRecipient[];
  monthlyReportTemplateType: MonthlyReportTemplateType;
  onDelete: (recipientId: MonthlyReportRecipient['id']) => void;
}

type RecipientsListProps = OwnProps;

type EditorState = { mode: 'create' } | { mode: 'edit'; recipientId: string };

const RecipientsList: React.FC<RecipientsListProps> = (props) => {
  const intl = useIntl();
  const { onDelete, recipients, monthlyReportTemplateType } = props;
  const [showEditor, setShowEditor] = React.useState<EditorState | null>(null);
  const recipientToEdit =
    showEditor?.mode === 'edit'
      ? recipients.find((r) => r.id === showEditor.recipientId)
      : undefined;

  React.useEffect(() => {
    setShowEditor(null);
  }, [recipients]);

  return (
    <div className='recipientsList'>
      {showEditor && (
        <RecipientEditorDialog
          mode={showEditor.mode}
          recipient={recipientToEdit}
          onClose={() => setShowEditor(null)}
        />
      )}
      <div className='list'>
        {recipients.length > 0 && (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{intl.formatMessage({ id: 'emailAddress' })}</TableCell>
                <TableCell>{intl.formatMessage({ id: 'language' })}</TableCell>
                <TableCell>{intl.formatMessage({ id: 'monthlyReportTemplate' })}</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {recipients.map((recipient) => (
                <Recipient
                  key={`recipient_${recipient.id}`}
                  recipient={recipient}
                  reportTemplateType={monthlyReportTemplateType}
                  onEdit={(recipient) => setShowEditor({ mode: 'edit', recipientId: recipient.id })}
                  onDelete={(recipient) => onDelete(recipient.id)}
                />
              ))}
            </TableBody>
            <TableFooter />
          </Table>
        )}

        <div className='recipientBtns'>
          <Button
            variant='contained'
            color='primary'
            onClick={() => setShowEditor({ mode: 'create' })}
            startIcon={<AddIcon />}
          >
            {intl.formatMessage({ id: 'addMailRecipient' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RecipientsList;
